var map = {
	"./25_2010.jpg": 3031,
	"./26_2010.jpg": 9053,
	"./27_2010.jpg": 1483,
	"assets/img/history-of-mikolajow/9/25_2010.jpg": 3031,
	"assets/img/history-of-mikolajow/9/26_2010.jpg": 9053,
	"assets/img/history-of-mikolajow/9/27_2010.jpg": 1483
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8869;